export const topics = [
  {
    id: "t1",
    name: "城市更新背后",
    summary: "从老旧小区改造到社区配套，追踪城市更新资金、进度与居民真实感受。",
    cover:
      "https://readdy.ai/api/search-image?query=Aging%20residential%20apartment%20blocks%20under%20renovation%20with%20scaffolding%2C%20dusk%20light%2C%20dark%20charcoal%20tones%20with%20subtle%20deep%20red%20accents%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=800&height=600&seq=911-topic-t1&orientation=landscape",
  },
  {
    id: "t2",
    name: "金融风险观察",
    summary: "围绕不良资产、灰色资金链与平台规则，梳理风险信号的来龙去脉。",
    cover:
      "https://readdy.ai/api/search-image?query=Financial%20district%20glass%20skyscrapers%20at%20dusk%20with%20glowing%20windows%2C%20moody%20dark%20charcoal%20palette%20and%20faint%20deep%20red%20light%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=800&height=600&seq=911-topic-t2&orientation=landscape",
  },
  {
    id: "t3",
    name: "突发事件档案",
    summary: "还原突发事件的现场、时间线与处置流程，记录每一次回应。",
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20highway%20at%20dawn%20with%20emergency%20vehicle%20light%20glow%20and%20mist%2C%20dark%20charcoal%20tones%20with%20deep%20red%20reflections%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=800&height=600&seq=911-topic-t3&orientation=landscape",
  },
  {
    id: "t4",
    name: "环境与公共健康",
    summary: "关注水质、空气、食品与公共健康领域的调查与整改回访。",
    cover:
      "https://readdy.ai/api/search-image?query=Industrial%20chimneys%20and%20pipes%20under%20overcast%20sky%20with%20faint%20steam%2C%20dark%20charcoal%20palette%20with%20subtle%20deep%20red%20ambient%20light%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=800&height=600&seq=911-topic-t4&orientation=landscape",
  },
];